module.exports = __webpack_public_path__ + "img/CB34bs-On-On-1.7fe52737.gif";